var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("img", {
        directives: [
          {
            name: "src",
            rawName: "v-src",
            value: _vm.logo,
            expression: "logo",
          },
        ],
        key: _vm.logo,
        staticClass: "logo",
        on: { click: _vm.enterCustoemBoard },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "nav-items-container" },
        [
          _c(
            "el-menu",
            {
              attrs: {
                "default-active": _vm.navActiveIndex,
                mode: "horizontal",
                "active-text-color": "#2362FB",
              },
              on: { select: _vm.navItemsClick },
            },
            [
              _vm._l(_vm.showItems, function (item, index) {
                return _c(
                  "el-menu-item",
                  { key: index, attrs: { index: item.path } },
                  [
                    _c("i", {
                      class: item.icon,
                      style: { fontSize: item.fontSize },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.title))]),
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "el-menu-item",
                { ref: "navManagerMenu", attrs: { index: "other" } },
                [_c("i", { staticClass: "wk wk-grid" })]
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-badge",
        {
          attrs: {
            value: _vm.unreadNums.announceCount,
            hidden:
              !_vm.unreadNums.announceCount ||
              _vm.unreadNums.announceCount == 0,
            max: 99,
          },
        },
        [
          _c("i", {
            staticClass: "wk wk-announcement",
            on: {
              click: function ($event) {
                return _vm.checkMessageDetail(true)
              },
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-badge",
        {
          attrs: {
            value: _vm.unreadNums.allCount,
            hidden: !_vm.unreadNums.allCount || _vm.unreadNums.allCount == 0,
            max: 99,
          },
        },
        [
          _c("i", {
            staticClass: "wk wk-bell",
            on: {
              click: function ($event) {
                return _vm.checkMessageDetail(false)
              },
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("system-message", {
        attrs: {
          visible: _vm.sysMessageShow,
          "unread-nums": _vm.unreadNums,
          "only-announcement": _vm.mesOnlyAnnouncement,
        },
        on: {
          "update:visible": function ($event) {
            _vm.sysMessageShow = $event
          },
          "update-count": _vm.sendSystemUnreadNum,
        },
      }),
      _vm._v(" "),
      _c(
        "el-dropdown",
        { attrs: { trigger: "click" }, on: { command: _vm.moreMenuClick } },
        [
          _c(
            "div",
            { staticClass: "user-container" },
            [
              _vm.userInfo && Object.keys(_vm.userInfo).length > 0
                ? [
                    _c("xr-avatar", {
                      staticClass: "user-img",
                      attrs: {
                        name: _vm.userInfo.realname,
                        size: 32,
                        src: _vm.userInfo.img,
                      },
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("i", { staticClass: "el-icon-caret-bottom mark" }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-dropdown-menu",
            {
              staticClass: "el-dropdown-unarrow",
              attrs: { slot: "dropdown" },
              slot: "dropdown",
            },
            [
              _vm._l(_vm.moreMenu, function (item, index) {
                return _c(
                  "el-dropdown-item",
                  {
                    key: index,
                    attrs: {
                      command: item.command,
                      divided: item.divided,
                      icon: item.icon,
                      disabled: item.disabled,
                    },
                  },
                  [_vm._v(_vm._s(item.label))]
                )
              }),
              _vm._v(" "),
              _vm.manage
                ? _c(
                    "div",
                    { staticClass: "handel-box" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "handel-button",
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.enterSystemSet()
                            },
                          },
                        },
                        [_vm._v("企业管理后台")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.navManagerShow
        ? _c("nav-manager", {
            ref: "navManager",
            attrs: { collapse: _vm.collapse, "top-module": _vm.items },
            on: {
              change: _vm.getTopHeaderModule,
              select: _vm.navManagerSelect,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }